// extracted by mini-css-extract-plugin
export var modal = "_4y-0";